import Rodo from '@/components/Rodo'
import headerComponent from '@/modules/header'

/**
 * @param {Element} root
 */
function createRootElementForRodoForm (root) {
  const placeholder = document.createElement('div')
  placeholder.classList.add('rodo-container')
  root.insertAdjacentElement('afterend', placeholder)
  return placeholder
}

function shouldInitRodoRegulations () {
  return document.querySelector('.rodo-regulations')
}

export function init () {
  headerComponent.logo(false)

  const form = document.querySelector('.rodo-form')
  const regulations = shouldInitRodoRegulations()

  if (form) {
    const root = createRootElementForRodoForm(form)
    new Rodo({ el: root, propsData: { form, regulations } })
  }
}



// WEBPACK FOOTER //
// ./src/modules/rodo.js